import { getLocale } from 'locales/utils';
import moment from 'moment';
import 'moment/locale/fr';

type FormatKey =
  | 'DATE_FORMAT_READABLE'
  | 'DATE_FORMAT_COMPACT'
  | 'DATE_FORMAT_FULL'
  | 'DATE_FORMAT_DATETIME'
  | 'DATE_FORMAT_SPLIT_TIME'
  | 'DATE_FORMAT_DATETIME_SHORT_MONTH';

const FORMAT_MAP: Record<FormatKey, Record<string, string>> = {
  DATE_FORMAT_READABLE: {
    en: 'MMMM DD, YYYY',
    fr: 'DD MMMM, YYYY',
  },
  DATE_FORMAT_COMPACT: {
    en: 'MMM DD, YYYY',
    fr: 'DD MMM, YYYY',
  },
  DATE_FORMAT_FULL: {
    en: 'MMMM DD, YYYY [at] hh:mm A',
    fr: 'DD MMMM, YYYY à HH:mm',
  },
  DATE_FORMAT_DATETIME: {
    en: 'MMMM DD, YYYY hh:mm A',
    fr: 'DD MMMM, YYYY HH:mm',
  },
  DATE_FORMAT_DATETIME_SHORT_MONTH: {
    en: 'MMM DD, YYYY hh:mm A',
    fr: 'DD MMM, YYYY HH:mm',
  },
  DATE_FORMAT_SPLIT_TIME: {
    en: 'MMM DD, YYYY|hh:mm A',
    fr: 'DD MMM, YYYY|HH:mm',
  },
};

export function formatDate(
  date: Date | string | number | null | undefined,
  formatKey: FormatKey,
) {
  if (!date) {
    return '';
  }

  const locale = getLocale();
  const isFrenchLocale = locale.includes('fr');
  const resolvedLocale = isFrenchLocale ? 'fr' : 'en';
  moment.locale(resolvedLocale);
  const formatString = FORMAT_MAP[formatKey][resolvedLocale];
  return moment(date).format(formatString);
}
